/**
 * ciało w lsnBase
 */
angular.module('ihestiaCommonDirectives.upperCase', []);